export const FxxlAccordion = (function FxxlAccordion() {
    function FxxlAccordion(element) {
        this.element = element;
        this.extended = false;
        this.autoExtend = false;
        this.activeClass = 'fxxl-accordion--active';
        this.showClass = 'fxxl-accordion--show';
        this.deactivatedClass = 'fxxl-accordion--deactivated';
        this.resetClass = 'fxxl-accordion--reset';
        this.headClass = 'fxxl-accordion__head';
        this.contentClass = 'fxxl-accordion__content';
        this.headElement = null;
        this.contentElement = null;
        this.lastScrollY = 0;
        this.autoExtendedLimit = 100;
        this.toggleTransitionDuration = 250; // ms -> From: _400_fxxl_accordion.scss -> &__content -> transition
        this.onOpened = function () {
            return true;
        };
        this.onOpenedAfterTransitionCallback = () => {};
        this.onOpenedAfterTransition = () => {
            setTimeout(this.onOpenedAfterTransitionCallback, this.toggleTransitionDuration);
            return true;
        };
        this.onClosed = function () {
            return true;
        };
        this.onClosedAfterTransitionCallback = () => {};
        this.onClosedAfterTransition = () => {
            setTimeout(this.onClosedAfterTransitionCallback, this.toggleTransitionDuration);
            return true;
        };
        this.init();
    }

    FxxlAccordion.prototype.init = function init() {
        if (this.element.getAttribute('data-extended') === '1') {
            this.extended = true;
        }
        if (this.element.getAttribute('data-auto-extend') === '1') {
            this.autoExtended = true;
        }
        this.headElement = this.element.getElementsByClassName(this.headClass)[0];
        this.contentElement = this.element.getElementsByClassName(this.contentClass)[0];
        this.setContentSize();
        this.events();
        if (this.extended === true) {
            this.toggleExtend(true);
        } else {
            this.toggleExtend(false);
        }
        this.element.classList.add(this.showClass);
        this.element.fxxlAccordion = this;
    };

    FxxlAccordion.prototype.setContentSize = function setContentSize() {
        this.element.classList.add(this.resetClass);
        this.contentElement.style.maxHeight = this.contentElement.offsetHeight + 'px';
        this.element.classList.remove(this.resetClass);
    };

    FxxlAccordion.prototype.toggleExtend = function toggleExtend(active) {
        if ((this.element.classList.contains(this.activeClass) === true && active === undefined) || active === false) {
            this.element.classList.remove(this.activeClass);
            this.element.classList.add(this.deactivatedClass);
            this.onClosed();
            this.onClosedAfterTransition();
        } else {
            this.element.classList.add(this.activeClass);
            this.element.classList.remove(this.deactivatedClass);
            this.onOpened();
            this.onOpenedAfterTransition();
        }
    };

    FxxlAccordion.prototype.events = function events() {
        var __this = this;

        this.headElement.addEventListener('click', function (e) {
            __this.toggleExtend();
            e.preventDefault();
        });

        new FxxlResizedEvent(function () {
            __this.setContentSize();
        });

        if (this.autoExtended === true) {
            window.addEventListener('scroll', function (e) {
                if (__this.lastScrollY < window.scrollY) {
                    requestAnimationFrame(function () {
                        if (((window.innerHeight + window.scrollY) + __this.autoExtendedLimit) >= document.body.offsetHeight) {
                            __this.toggleExtend(true);
                        }
                    });
                }
                __this.lastScrollY = window.scrollY;
            });
        }
    };

    return FxxlAccordion;
}());